import React from 'react';
import { Box, Text, Link, VStack, HStack, Icon } from '@chakra-ui/react';
import { User, Link as LinkIcon, Buildings } from '@phosphor-icons/react';

const CreditDisplay = ({ credits }) => {
  if (!credits) {
    return null;
  }

  const { photographer, source, license, website, organization } = credits;

  return (
    <VStack align="stretch" spacing={2}>
      {photographer && (
        <HStack>
          <Icon as={User} />
          <Text>Photographer: {photographer}</Text>
        </HStack>
      )}
      {source && (
        <HStack>
          <Text>Source: {source}</Text>
        </HStack>
      )}
      {license && (
        <HStack>
          <Text>License: {license}</Text>
        </HStack>
      )}
      {website && (
        <HStack>
          <Icon as={LinkIcon} />
          <Link href={website} isExternal>
            {website}
          </Link>
        </HStack>
      )}
      {organization && (
        <HStack>
          <Icon as={Buildings} />
          <Text>Organization: {organization}</Text>
        </HStack>
      )}
    </VStack>
  );
};

export default CreditDisplay;
